module.exports = __webpack_public_path__ + "d1a353bdc1b31525e96b7a7ce60ce9f8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/pn.mp3
// module id = 1935
// module chunks = 4